<script>
  import Subject from './Subject.svelte';
  import SubjectForm from './form/Subject.svelte';
  import Index from './Index.svelte';
  import Link from './Link.svelte';
  import SearchView from './view/Search.svelte';
  import { categories as default_categories_store } from './stores.js';
  
  export let user = null;
  export let categories_store = default_categories_store;
  
  function getUser() {
    fetch(`/user.jsr`)
      .then(function(r) {
        if (r.ok) return r;
        if (r.code != 401) throw Error(r.statusText);
      })
      .then(r => r.json())
      .then(data => {
        user = data.data[0]
      })
      .catch(function(error) {
        console.log(error);
      });
  }
  
  
  import { onMount } from "svelte";
  import { Route, router } from "tinro";
  import request from 'superagent';
  import ChildMenu from './../../../../components/menu/ChildMenu.svelte';
  import Select from "svelte-select";
  import PostList from './PostList.svelte';
  import Grid from './Grid.svelte';
  import List from './List.svelte';
  import Item from './Item.svelte';
  import FeedProposals from './FeedProposals.svelte';
  import FeedForm from './form/Feed.svelte';
  import ItemForm from './form/Item.svelte';
  import TopicForm from './form/Topic.svelte';
  import TopicFeedForm from './form/TopicFeed.svelte';
  import Search from './Search.svelte';
  import KurzyView from './view/Kurzy.svelte';
  import { topics as default_topics_store } from './stores.js';
  
  window.major = {};
  
  const SEARCH_TYPE_TAM = 1;
  const SEARCH_TYPE_SEARX = 2;
  const PAGE_SIZE = 20;
  const defaultFeed = { name: "", uri: "", format: "", xpath: ""
    //freshness_minutes
  }
  const defaultTopic = {children: []};
  
  const getOptionLabel = (option) => option.name;
  const getSelectionLabel = (option) => option.name;
  
  export let url = window.location.pathname;
  export let active_feed_id = null;
  export let active_topic_slug = null;
  export let page = 1;
  export let topics_store = default_topics_store;
  export let topics_json = null;
  export let my = true;
  
  export let topic_form_id = window.TOPIC_FORM_ID;
  export let feed_form_id = window.FEED_FORM_ID;
  export let item_form_id = window.ITEM_FORM_ID;
  export let link_form_id = window.LINK_FORM_ID;
  
  let search_terms = [];
  let search_term = '';
  let search_type = SEARCH_TYPE_TAM;
  
  let topics = [];
  let items = [];
  let feed = {};
  let item = {};
  let right_items = []; // items possibly visible right
  let right_item = null; // item shown right
  let video_topics = {};
  
  let visible_right_sidebar = true;
  let visible_postlist = true;
  let visible_item_form = false;
  let visible_feed_form = false;
  let visible_topic_form = false;
  let visible_favorite_only = false;
  let visible_feed_list = false;
  let visible_posts = 'www';
  let visible_help = false;
  let visible_search = true;
  
  let selected_value = null;
  let post_list_url = "/p/news/posts.json";
  
  // $: visible_right_sidebar = (!!user && (user.mod || my));
  
  function windowBack() {
    window.history.back();
  }
  
  function onTopicOpened(ev) {
    if (!ev.detail.topic_slug.length || active_topic_slug == ev.detail.topic_slug)
      return;
    active_topic_slug = ev.detail.topic_slug;
    search_term = "";
    page = 1;
  }
  
  function onFeed(ev) {
    feeds = [...feeds, ev.detail];
    toggleFeedForm();
  }
  
  function onTopic(ev) {
    console.log(ev.detail);
    appendTopic(ev.detail);
    toggleTopicForm();
    page = 1;
  }
  
  function onSearchInput(ev) {
    page = 1;
    search_terms = [...search_terms, search_term];
    console.log(search_terms);
  }
  
  function onItem(ev) {
    //delete ev.detail['exists'];
    if (!ev.detail) {
      visible_item_form = false;
      return;
    }
    item = ev.detail;
    let slug = item.id;
    item.id = window.atob(slug);
    let new_url = `/n/` + slug;
    url = new_url;
  }
  
  function setRightItem() {
    if (item) {
      let i = right_items.length;
      right_items = [...right_items, item];
      toggleRightItem(i);
      windowBack();
    }
  }
  
  function showVideoOnRightItem(item_id, video) {
    let item = {id: item_id, video_to_play: video};
    let i = right_items.length;
    right_items = [...right_items, item];
    toggleRightItem(i);
  }
  
  function unsetRightItem(index) {
    let tmp = right_items;
    tmp.splice(index, 1);
    right_items = tmp;
    if (right_items.length)
      right_item = index > 0 ? right_items[index - 1] : right_items[0];
    else
      right_item = null;
  }
  
  function markVideoTopics() {
    function recursiveMarking(items) {
      for (const item of items) {
        video_topics[item.id] = null;
        if (item.children)
          recursiveMarking(item.children);
      }
    }
    for (const topic of topics)
      if (topic.id == "audio" || topic.id == "video") {
        video_topics[topic.id] = null;
        recursiveMarking(topic.children);
      }
  }
  
  function proposeFeed(ev) {
    feed = ev.detail;
    toggleFeedForm();
  }
  
  function showStream() {
    visible_feed_form = false;
    visible_feed_list = false;
  }
  
  function togglePrices() {
    visible_postlist = false;
    right_item = null;
  }
  
  function togglePostList() {
    if (!visible_postlist)
      right_item = null;
    visible_postlist = true;
  }
  
  function toggleHelp() {
    visible_help = !visible_help;
  }
  
  function toggleTopicForm() {
    if (visible_item_form) toggleItemForm();
    visible_topic_form = !visible_topic_form;
  }
  
  function toggleItemForm(create) {
    if (create === true)
      item = {};
    if (visible_topic_form) toggleTopicForm();
    visible_item_form = !visible_item_form;
  }
  
  function toggleFavoriteOnly() {
    visible_favorite_only = !visible_favorite_only;
  }
  
  function toggleFeedForm() {
    visible_feed_form = !visible_feed_form;
  }
  
  function toggleFeedList() {
    if (visible_feed_form)
      visible_feed_form = false;
    visible_feed_list = !visible_feed_list;
  }
  
  function toggleSearch() {
    if (visible_search) {
      search_term = "";
      changePage(1);
    }
    visible_search = !visible_search;
  }
  
  function togglePosts(tab='www') {
    switch(tab) {
    case 'www':
    case 'vdo':
      visible_posts = tab;
      break;
    default:
      visible_posts = 'www';
    }
  }
  
  function changePage(p) {
    if (p <= 0)
      p = 1;
    page = p;
  }
  
  function getApiPrefixForList(topic_slug) {
    if (my)
      return "/my/feeds/topics";
    if (topic_slug && video_topics[topic_slug] === null)
      return "/p/news/videos";
    return "/p/news/topics";
  }
  
  function appendTopic(topic) {
    if (topic["parent_id"] && topic.parent_id.length) {
      if (video_topics[topic.parent_id] === null)
        video_topics[topic.id] = null;
  
      for (var l1 in topics) {
        var l1_children = topics[l1].children;
        if (topics[l1].id == topic.parent_id) {
          topics[l1].children = [...l1_children, topic];
          break;
        }
  
        for (var l2 in l1_children) {
          var l2_children = l1_children[l2].children;
          if (l1_children[l2].id == topic.parent_id) {
            topics[l1].children[l2].children = [...l2_children, topic];
            break;
          }
          if (!l2_children) break;
  
          for (var l3 in l2_children) {
            var l3_children = l2_children[l3].children;
            if (l2_children[l3].id == topic.parent_id) {
              topics[l1].children[l2].children[l3].children = [...l3_children, topic];
              break;
            }
            if (!l3_children) break;
  
            for (var l4 in l3_children) {
              var l4_children = l3_children[l4].children;
              if (l3_children[l4].id == topic.parent_id) {
                topics[l1].children[l2].children[l3].children[l4].children = [...l4_children, topic];
                break;
              }
              if (!l4_children) break;
            }
          }
        }
      }
    }
    else
      topics = [...topics, topic];
  }
  
  
  
  let categories = [];
  let subjects = [];
  let subject = {};
  
  let visible_subject_form = false;
  let visible_topics_menu = 0;
  let visible_categories_menu = !visible_topics_menu;
  let visible_front_items = true;
  
  let front_items = [];
  
  function onCategoryOpened(ev) {
    if (!ev.detail.category_slug.length || active_category_slug == ev.detail.category_slug)
      return;
    active_category_slug = ev.detail.category_slug;
    page = 1;
  }
  
  function onCategory(ev) {
    appendCategory(ev.detail);
    toggleCategoryForm();
    page = 1;
  }
  
  function onSubject(ev) {
    if (!ev.detail) {
      visible_subject_form = false;
      return;
    }
    subject = ev.detail;
    let slug = subject.id;
    subject.id = window.atob(slug);
    let new_url = `/ix/x/` + slug;
    url = new_url;
  }
  
  function toggleRightItem(i) {
    if (right_item == null) {
      visible_postlist = false;
      visible_front_items = false;
    }
    right_item = i;
  }
  
  function toggleFrontItems() {
    if (visible_postlist) {
      visible_postlist = false
    }
    right_item = null;
    visible_front_items = true;
  }
  
  function toggleSubjectForm(force) {
    visible_subject_form = !visible_subject_form;
    if (force)
      visible_subject_form = true;
  }
  
  function toggleMenu(index_of_roots) {
    if (visible_topics_menu < 0 || visible_topics_menu == index_of_roots) {
      visible_topics_menu = 0;
      active_topic_slug = null;
    }
    else
      visible_topics_menu = index_of_roots;
  
    //visible_right_sidebar = visible_topics_menu != 0;
    visible_categories_menu = (index_of_roots == -1);
  }
  
  function getFrontItems() {
    fetch("/p/news/front.json")
      .then(r => r.json())
      .then(data => {
        if (data.count > 0) {
          if (!(Array.isArray(data.data) || data.data instanceof Array))
            front_items = [data.data];
          else {
            front_items = data.data;
          }
        }
      })
  }
  
  function init() {
    getUser();
    getFrontItems();
    my = false;
    topics_store.subscribe(value => {
      if (value  != 'undefined' || !value) {
        topics = value;
        markVideoTopics();
      }
    });
  
    router.subscribe(value => {
      if (value.path.substring(0, 2) != '/t')
        return;
      active_topic_slug = value.path.substring(3);
      // visible_right_sidebar = !(video_topics[active_topic_slug] === null);
    });
  
  
    categories_store.subscribe(value => {
      if (value  != 'undefined' || !value)
        categories = value;
    });
    visible_search = true;
    visible_right_sidebar = true;
    visible_postlist = false;
  }
  
  onMount(init);
</script>
<nav class='navbar navbar-light bg-white justify-content-between shadow-sm'>
<ul class='nav flex-row'>
<li class='nav-item'>
<a class='nav-link' href='/' tinro-ignore title='Informační servis'>
<i class='fas fa-external-link-alt'></i>
Obsah
</a>
</li>
<li class='nav-item'>
<a class='nav-link' href='/c' tinro-ignore title='Kalendář'>
<i class='far fa-calendar-alt'></i>
Kalendář
</a>
</li>
<li class='nav-item'>
<a class='nav-link' href='/w' tinro-ignore title='Počasí ČR'>
<i class='wi wi-day-sunny-overcast'></i>
Počasí
</a>
</li>
{#if user}
<li class='nav-item'>
<a class='nav-link text-primary' href='/f' rel='nofollow' tinro-ignore title='Odběry novinek'>
<i class='fa fa-star'></i>
</a>
</li>
<li class='nav-item'>
<a class='nav-link text-primary' href='/a' rel='nofollow' tinro-ignore title='Strojová analýza textového obsahu'>
<i class='fa fa-graduation-cap'></i>
</a>
</li>
<li class='nav-item'>
<a class='nav-link text-success' href='/nlp' rel='nofollow' tinro-ignore title='Tvorba analytických modelů'>
<i class='fa fa-chalkboard-teacher'></i>
</a>
</li>
<li class='nav-item'>
<a class='nav-link text-success' href='/kb' rel='nofollow' tinro-ignore title='Znalostní báze'>
<i class='fa fa-book'></i>
</a>
</li>
<li class='nav-item'>
<a class='nav-link text-success' href='/e' rel='nofollow' tinro-ignore title='Editor'>
<i class='fa fa-edit'></i>
</a>
</li>
{/if}
<li class='nav-item'>
<a class='nav-link' href='/info' rel='nofollow' tinro-ignore>
<i class='fa fa-info'></i>
</a>
</li>
</ul>
<ul class='nav flex-row'>
{#if user}
<li class='nav-item'>
<a class='nav-link text-primary' href='/profile' rel='nofollow' tinro-ignore title='Nastavení'>
<i class='fa fa-cog'></i>
</a>
</li>
{:else}
<li class='nav-item'>
<a class='nav-link text-primary' href='/html/account.html' rel='nofollow' tinro-ignore>Přihlášení</a>
</li>
{/if}
</ul>

</nav>
<div class='container-fluid min-h-100 grad4 pb-5 pr-4'>
<div class='row min-h-100'>
<div class='col-2 p-0'>
<div class='d-flex flex-column justify-content-between'>
<div class='nav nav-tabs p-0 mt-3 border-0 flex-column' id='menu'>
{#each topics as {id, title, image, about, children}, i}
<h6 class='nav-item'>
{#if !visible_topics_menu || i+1==visible_topics_menu}
<a class:grad4='{visible_topics_menu==i+1}' class='nav-link font-weight-bold' href='/t/{id}' on:click|preventDefault='{() => toggleMenu(i+1)}' on:keyup|preventDefault='{() => toggleMenu(i+1)}' role='button' title='{about}'>
<i class:fa-external-link-alt='{visible_topics_menu!=i+1}' class:fa-times='{visible_topics_menu==i+1}' class='fas'></i>
{title}
</a>
{/if}
{#if visible_topics_menu && i+1==visible_topics_menu}
<div class='px-3 text-darker border-left border-info'>
<ChildMenu active_id='{active_topic_slug}' items='{children}' url_prefix='/t'></ChildMenu>
</div>
{/if}
</h6>
{/each}
</div>
</div>
</div>
<div class='col-10 d-flex flex-column'>
<div class='row'>
<div class='col-6'>
<form class='form-inline mb-2 p-3 d-flex flex-column'>
{#if visible_search}
<div class='form-group w-100'>
<input aria-label='Hledat' bind:value='{search_term}' class='form-control mr-sm-2 ui w-75' placeholder='Hledaný výraz' type='search'>
<button class='btn btn-outline-default my-2 my-sm-0 shadow-none' on:click|preventDefault='{onSearchInput}'>
<i class='fa fa-search'></i>
</button>
</div>
<small class='d-flex w-100'>
<div class='d-flex mx-2'>
<input bind:group='{search_type}' checked name='search' type='radio' value='{SEARCH_TYPE_TAM}'>
<label>TAM</label>
</div>
<div class='d-flex mx-2'>
<input bind:group='{search_type}' name='search' type='radio' value='{SEARCH_TYPE_SEARX}'>
<label>Internet</label>
</div>
</small>
{/if}
</form>

</div>
</div>
<div class='row'>
<div class='col'></div>
</div>
<div class='row rt bg-white h-100 flex-grow-1'>
<div class:col-md-6='{visible_right_sidebar}' class='col-12'>
<div>
{#if user && visible_item_form}
<ItemForm item='{item}' item_form_id='{item_form_id}' on:item='{onItem}' topics_store='{topics_store}'></ItemForm>
{:else}
<Route let:meta path='{my ? '/f' : ''}/n/:slug'>
<div class='d-flex justify-content-between'>
<span>
<button class='btn btn-link' on:click='{()=>{windowBack()} }' on:keyup='{()=>{windowBack()} }'>
<i class='fa fa-arrow-left'></i>
</button>
{#if user}
<button class:btn-outline-danger='{!my}' class:btn-outline-primary='{my}' class='btn border-0' on:click='{toggleItemForm}'>
<i class='fa fa-edit'></i>
</button>
{/if}
</span>
<span>
<button class='btn btn-link' on:click='{()=>{setRightItem()} }' on:keyup='{()=>setRightItem()}'>
<i class='fa fa-angle-double-right'></i>
</button>
</span>
</div>
<Item api_prefix='{my ? '/my/feeds/items' : '/p/news/items'}' id='{meta.params.slug}' item_form_id='{item_form_id}' on:item='{onItem}' url_prefix='{my ? '/f' : ''}' user='{user}'></Item>
</Route>
<Route let:meta path='{my ? '/f' : ''}/t/:slug'>
<div class='d-flex justify-content-between'>
{#if user}
<button class:active='{visible_item_form}' class='btn border-0 btn-outline-primary' on:click|preventDefault='{() => toggleItemForm(true)}' title='Nový soubor'>
<i class='fa fa-plus'></i>
</button>
{/if}
</div>
{#if search_term.length && search_terms.length}
<div class='listing'>
{#if search_type == SEARCH_TYPE_TAM}
<List additional_query='&q={search_term}' api_prefix='/p/news' bind:page='{page}' on:item='{onItem}' resource='fulltext' url_prefix='{my ? '/f' : ''}' visible_about='{false}'></List>
{:else if search_type == SEARCH_TYPE_SEARX}
{#each search_terms as term, i}
<div class='search-item'>
<SearchView query='{search_terms[i]}'></SearchView>
</div>
{/each}
{/if}
</div>
{:else}
<div class='listing'>
<List api_prefix='{getApiPrefixForList(meta.params.slug)}' bind:page='{page}' force_video_content='{video_topics[meta.params.slug]===null}' on:item='{onItem}' on:topicOpened='{onTopicOpened}' topic_slug='{meta.params.slug}' url_prefix='{my ? '/f' : ''}' visible_about='{false}'></List>
</div>
{/if}
</Route>
<Route path='/'>
{#if search_term.length && search_terms.length}
<div class='listing'>
{#if search_type == SEARCH_TYPE_TAM}
<List additional_query='&q={search_term}' api_prefix='/p/news' bind:page='{page}' on:item='{onItem}' resource='fulltext' url_prefix='{my ? '/f' : ''}' visible_about='{false}'></List>
{:else if search_type == SEARCH_TYPE_SEARX}
{#each search_terms as term, i}
<div class='search-item'>
<SearchView query='{search_terms[i]}'></SearchView>
</div>
{/each}
{/if}
</div>
{:else}
<div class='listing'>
{#if !items}
{/if}
<ol class='items-list list-group groups'>
{#each front_items as item, i}
{#if item.videos}
<li class='list-group-item border-0 px-1 card'>
<h5 class='card-header'>
<a href='/n/{item.id}'>{item.title}</a>
</h5>
<section class='videos d-flex flex-row card-body'>
{#each item.videos as video, i}
<div class='mx-1' on:click|preventDefault='{() => showVideoOnRightItem(item.id, video)}' on:keyup|preventDefault='{() => showVideoOnRightItem(item.id, video)}' style='width: 178px'>
<div class='d-none d-lg-block' index='{i}'>
<img class='my-1 rounded-lg' src='{video.image}' width='178'>
</div>
<a class='d-block' href='{video.uri}' index='{i}' target='_blank' title='{video.title}'>
<div class='elpsis'>
{video.title}
</div>
</a>
</div>
{/each}
</section>
</li>
{/if}
{/each}
</ol>

<!-- /%Grid{"bind:page":"{page}", "on:topicOpened": "{onTopicOpened}", "on:item": "{onItem}", url_prefix: "{my ? '/f' : ''}", resource: "news", visible_about: "{false}"} -->
</div>
{/if}
</Route>

<Route let:meta path='/ix/:slug'>
<div class='d-flex justify-content-between'>
<button class:active='{visible_subject_form}' class='btn border-0 btn-outline-info' on:click|preventDefault='{() => toggleSubjectForm(true)}' on:keyup|preventDefault='{() => toggleSubjectForm(true)}' title='Nová znalost'>
<i class='fa fa-plus'></i>
</button>
</div>
{#if visible_subject_form}
<SubjectForm categories='{categories}' subject_form_id='{item_form_id}'></SubjectForm>
{:else}
<div class='bg-white shadow-sm'>
{#if search_term}
<Index additional_query='&q={search_term}' bind:page='{page}' on:categoryOpened='{onCategoryOpened}' on:subject='{onSubject}' resource='fulltext'></Index>
{:else}
<Index bind:page='{page}' category_slug='{meta.params.slug}' on:categoryOpened='{onCategoryOpened}' on:subject='{onSubject}'></Index>
{/if}
</div>
{/if}
</Route>
<Route let:meta path='/ix/:category_slug/:slug'>
{#if visible_subject_form}
<SubjectForm categories='{categories}' id='{meta.params.slug}' on:subject='{onSubject}' subject='{subject}' subject_form_id='{item_form_id}'></SubjectForm>
{:else}
<div class='d-flex justify-content-between'>
<span>
<button class='btn btn-link' on:click='{()=>{windowBack()} }' on:keyup='{()=>{windowBack()} }'>
<i class='fa fa-a2rrow-left'></i>
</button>
{#if user}
<button class:btn-outline-danger='{!my}' class:btn-outline-primary='{my}' class='btn border-0' on:click='{toggleSubjectForm}'>
<i class='fa fa-edit'></i>
</button>
{/if}
</span>
<span>
<button class='btn btn-link' on:click='{()=>{setRightItem()} }' on:keyup='{()=>setRightItem()}'>
<i class='fa fa-angle-double-right'></i>
</button>
</span>
</div>
<Subject id='{meta.params.slug}' on:subject='{onSubject}' subject_form_id='{item_form_id}' user='{user}'></Subject>
{/if}
</Route>
<Route let:meta path='/x/:slug'>
{#if visible_subject_form}
<SubjectForm categories='{categories}' id='{meta.params.slug}' on:subject='{onSubject}' subject='{subject}' subject_form_id='{item_form_id}'></SubjectForm>
{:else}
<div class='d-flex justify-content-between'>
<span>
<button class='btn btn-link' on:click='{()=>{windowBack()} }' on:keyup='{()=>{windowBack()} }'>
<i class='fa fa-arrow-left'></i>
</button>
{#if user}
<button class:btn-outline-danger='{!my}' class:btn-outline-primary='{my}' class='btn border-0' on:click='{toggleSubjectForm}'>
<i class='fa fa-edit'></i>
</button>
{/if}
</span>
<span>
<button class='btn btn-link' on:click='{()=>{setRightItem()} }' on:keyup='{()=>setRightItem()}'>
<i class='fa fa-angle-double-right'></i>
</button>
</span>
</div>
<Subject id='{meta.params.slug}' on:subject='{onSubject}' subject_form_id='{item_form_id}' user='{user}'></Subject>
{/if}
</Route>
{/if}
</div>
</div>
<div class:hidden='{!visible_right_sidebar}' class='col-12 col-md-6'>
<div class='scroll mx-xl-3 mb-4'>
{#if active_topic_slug && user && user.mod}
<TopicFeedForm topic_slug='{active_topic_slug}'></TopicFeedForm>
{/if}
<ul class='nav flex-row'>
<li class='nav-item'>
<div class='nav-link text-dark' on:click|preventDefault='{() => toggleFrontItems()}' on:keyup|preventDefault='{() => toggleFrontItems()}' title='Články podle témat'>
<i class='fa fa-star'></i>
</div>
</li>
<li class='nav-item'>
<div class='nav-link text-dark' on:click|preventDefault='{() => togglePostList()}' on:keyup|preventDefault='{() => togglePostList()}' title='Stream novinek'>
<i class='fa fa-stream'></i>
</div>
</li>
{#each right_items as ritem, i}
<li class='nav-item'>
{#if i == right_item}
<div class='h6 nav-link text-link' on:click|preventDefault='{() => unsetRightItem(i)}' on:keyup|preventDefault='{() => unsetRightItem(i)}'>
<span class='badge badge-dark'>
&times;
</span>
</div>
{:else}
<div class='h6 nav-link text-link' on:click|preventDefault='{() => toggleRightItem(i)}' on:keyup|preventDefault='{() => toggleRightItem(i)}'>
<span class='badge badge-light'>
{i+1}
</span>
</div>
{/if}
</li>
{/each}
</ul>
{#if visible_postlist}
<PostList have_feed_list='{false}' have_time='{user && user.mod}'></PostList>
{:else if visible_front_items}
{#if active_topic_slug}
{#key active_topic_slug}
<PostList have_feed_list='{false}' have_kinds='{false}' have_tags='{false}' have_time='{user && user.mod}' url='/p/news/topics_posts/{active_topic_slug}.json'></PostList>
{/key}
{:else}
{#if !items}
{/if}
<ol class='items-list list-group groups'>
{#each front_items as item, i}
{#if item.links}
<li class='list-group-item border-0 px-1 card'>
<h5 class='card-header mb-2'>
<a href='/n/{item.id}'>{item.title}</a>
</h5>
<section class='links d-flex flex-column'>
{#each item.links as link, i}
<div class='mx-2 mb-2'>
<Link elipsis='{true}' link='{link}' link_id='{link.id}' visible_star='{false}'></Link>
</div>
{/each}
</section>
</li>
{/if}
{/each}
</ol>

{/if}
{/if}
<div class:d-none='{right_item == null}' class='shadow'>
{#each right_items as ritem, i}
<section class:d-none='{i != right_item}'>
<Item api_prefix='/p/news/items' id='{ritem.id}' item='{right_items[i]}' item_form_id='{item_form_id}' on:item='{onItem}' url_prefix='{my ? '/f' : ''}' user='{user}'></Item>
</section>
{/each}
</div>

</div>
</div>
</div>
</div>

</div>
</div>
<div class='container-fluid bg-light py-5'>
<div class='row'>
<div class='col-6 col-xl-4'>
<KurzyView></KurzyView>
</div>
</div>
</div>
